import { Stack, Container } from "@mui/material";
//zui
import { useTranslation } from 'react-i18next';

import { Label } from 'src/@/components/ui/label';
import { RadioGroup, RadioGroupItem } from 'src/@/components/ui/radio-group';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "src/@/components/ui/tooltip";

const getOptionsTypePrompt = (t) => [
    { value: 'stepByStep', label: t('aiAgents.promptType.preConfiguredLabel', 'Pré-configurado'), desc: t('aiAgents.promptType.preConfiguredDescription', 'Use nosso passo a passo para criar seu agente de forma fácil e pré-configurada'), recommended: true },
    { value: 'promptFree', label: t('aiAgents.promptType.customLabel', 'Customizado'), desc: t('aiAgents.promptType.customDescription', 'Indicado para construir um agente com prompt livre'), recommended: false }
];

const Item1 = ({
    changePromptType,
    aiAgent
}) => {
    const { t } = useTranslation('settings');
    const optionsTypePrompt = getOptionsTypePrompt(t);

    return (
    <>
        <RadioGroup
            value={aiAgent?.config?.generalConfig?.type}
            onValueChange={(value) => changePromptType(value)}
            className=" grid grid-cols-2 gap-2 w-full"
        >
            {optionsTypePrompt.map((option) => (
                <TooltipProvider>
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <div className='w-full' key={option.value}>
                                <RadioGroupItem
                                    value={option.value}
                                    id={option.value}
                                    className="peer sr-only "
                                />
                                <Label
                                    htmlFor={option.value}
                                    className={`flex flex-col items-center h-32 justify-center  rounded-md border-2 border-muted bg-popover p-2 hover:bg-violet-400 hover:text-white ${aiAgent?.config?.generalConfig?.type === option.value ? 'border-violet-300 text-pretty' : ''}`}
                                >
                                    <h4 className="scroll-m-20 text-lg font-semibold tracking-tight">
                                        {option.label}
                                    </h4>
                                    <p className="leading-4 text-xs text-center [&:not(:first-child)]:mt-6">{option.desc}</p>


                                </Label>
                            </div>
                        </TooltipTrigger>
                        <TooltipContent className="bg-slate-900 text-white">
                            <p>{option.desc}</p>
                        </TooltipContent>
                    </Tooltip>
                </TooltipProvider>

            ))}
        </RadioGroup>
    </>
    );
};

const Item2 = ({
    changePromptType,
    aiAgent
}) => {
    const { t } = useTranslation('settings');
    const optionsTypePrompt = getOptionsTypePrompt(t);

    return (
    <div>
        <RadioGroup
            value={aiAgent?.config?.generalConfig?.type}
            onValueChange={(value) => changePromptType(value)}
            className="w-full flex flex-row"
        >
            {optionsTypePrompt.map((option) => (
                <TooltipProvider>
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <div className='w-1/3' key={option.value}>
                                <RadioGroupItem
                                    value={option.value}
                                    id={option.value}
                                    className="peer sr-only "
                                />
                                <Label
                                    htmlFor={option.value}
                                    className={`flex flex-col text-left items-center justify-center rounded-md border-2 border-muted bg-popover p-2 hover:bg-violet-400 hover:text-white ${aiAgent?.config?.generalConfig?.type === option.value ? 'border-violet-300 bg-violet-100 text-pretty' : ''}`}
                                >
                                    <h5 className="text-xs text-left">
                                        {option.label}
                                    </h5>
                                    <p className="leading-4 text-xs text-left [&:not(:first-child)]:mt-2">{option.desc}</p>


                                </Label>
                            </div>
                        </TooltipTrigger>
                        <TooltipContent className="bg-slate-900 text-white">
                            <p>{option.desc}</p>
                        </TooltipContent>
                    </Tooltip>
                </TooltipProvider>

            ))}
        </RadioGroup>
    </div>
    );
};

export default function AiSelectPromptType({
    aiAgent,
    changePromptType,
    source
}) {

    return (
        <>
            {source === 'stepByStep' && <Item1
                aiAgent={aiAgent}
                changePromptType={changePromptType}
            />}

            {source === 'details' && <Item2
                aiAgent={aiAgent}
                changePromptType={changePromptType}
            />}

        </>

    )

}